import { AppUser, drMedia, drRepository } from '@robisoft/cross-library';

export class OptionId
{
    id: number;
    descr: string;

    constructor()
    {
        this.id = 0;
        this.descr = '';
    }
}

export class GetPacchettiReq
{
    store: string;
    myToken: string;
    region: string;
    
    constructor()
    {
        this.store = '';
        this.myToken = '';
        this.region = '';
    }
}

export class GetPacchettiResp
{
    error: string;
    pacchetti: drRepository[] | null;
    
    constructor()
    {
        this.error = '';
        this.pacchetti = null;
    }
}

export class GetHotelInfoReq
{
    store: string;
    hotelId: number;

    constructor()
    {
        this.store = '';
        this.hotelId = 0;
    }
}

export class GetHotelInfoResp
{
    error: string;
    hotel: AppUser | null;
    gallery: drMedia[] | null;

    constructor()
    {
        this.error = '';
        this.hotel = null;
        this.gallery = null;
    }
}

export class GetShopCartReq {
    store: string;
    myToken: string;
    partenzaId: number;
    percorsoId: number;
    qty: number;
    qtyGolfcar: number;
    qtyCarrelli: number;
    qtyCarrelliEl: number;
    qtySacche: number;

    nome1: string;
    nome2: string;
    nome3: string;
    nome4: string;
    email1: string;
    email2: string;
    email3: string;
    email4: string;
    hcp1: string;
    hcp2: string;
    hcp3: string;
    hcp4: string;

    note: string;
    telefono: string;
    nazione: string;
    newsletter: boolean;

    constructor() {
        this.store = '';
        this.myToken = '';
        this.partenzaId = 0;
        this.percorsoId = 0;
        this.qty = 1;
        this.qtyGolfcar = 0;
        this.qtyCarrelli = 0;
        this.qtyCarrelliEl = 0;
        this.qtySacche = 0;

        this.nome1 = '';
        this.nome2 = '';
        this.nome3 = '';
        this.nome4 = '';
        this.email1 = '';
        this.email2 = '';
        this.email3 = '';
        this.email4 = '';
        this.hcp1 = '';
        this.hcp2 = '';
        this.hcp3 = '';
        this.hcp4 = '';
        this.note = '';
        this.telefono = '';
        this.nazione = '';
        this.newsletter = false;
    }
}

export class GetShopCartResp {
    error: string;
    prenotazioneId: number;
    ricevutaNum: number;
    ricevutaId: number;

    constructor() {
        this.error = '';
        this.prenotazioneId = 0;
        this.ricevutaNum = 0;
        this.ricevutaId = 0;
    }
}